import { Menu, usePermissions } from 'react-admin';
import LabelIcon from '@mui/icons-material/Label';
import CustomMenu from './CustomMenu';
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

export const MyMenu = () => {
    const { permissions } = usePermissions();
    return (<Menu>
        {permissions && permissions.role!='' && permissions.role == "SuperAdmin" ? <Menu.ResourceItem name="sbomodules" /> : null}
        {useCheckPermissions('AdminUser_View') ? <Menu.ResourceItem name="adminuser" /> : null}
        {useCheckPermissions('PendingUser_View') ? <Menu.ResourceItem name="pendinguser" /> : null}
        {useCheckPermissions('User_View') ? <Menu.ResourceItem name="user" /> : null}
        {useCheckPermissions('BasicSettings_View') ? <Menu.ResourceItem name="basicsettings" /> : null}
        {useCheckPermissions('PublicCloudStorageList_View') ? <Menu.ResourceItem name="publiccloudstoragelist" /> : null}
    </Menu>
    )

}